<template>
  <div class="pagination-container">
    <paginate 
      v-model="currentPage"
      :page-count="pageCount"
      :click-handler="fetchPage"
      :prev-text="'上一頁'"
      :next-text="'下一頁'"
      :container-class="'pagination'"
      :page-class="'page-item'"
      :prev-class="'page-item'"
      :next-class="'page-item'"
      :page-link-class="'page-link'"
      :prev-link-class="'page-link'"
      :next-link-class="'page-link'"
      :disabled-class="'disabled'"
    />
  </div>
</template>

<script>
import Paginate from 'vuejs-paginate-next';

export default {
  components: {
    Paginate
  },
  props: {
    totalItems: {
      type: Number,
      required: true
    },
    itemsPerPage: {
      type: Number,
      default: 10
    }
  },
  data() {
    return {
      currentPage: 1
    };
  },
  computed: {
    pageCount() {
      return Math.ceil(this.totalItems / this.itemsPerPage);
    }
  },
  methods: {
    fetchPage(pageNumber) {
      this.currentPage = pageNumber;
      this.$emit('onFetchPage', pageNumber);
    }
  }
};
</script>

<style>
.page-item {
  cursor: pointer;
}

.pagination-container {
  display: flex;
  justify-content: center;
}
</style>
